import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import { Permission } from '@/hooks/use-permissions';

interface AccessDeniedProps {
  permission?: Permission | Permission[];
  message?: string;
}

export function AccessDenied({ permission, message }: AccessDeniedProps) {
  const { t } = useTranslation(['common']);
  
  const displayMessage = message || t('common:accessDenied.message', 'You don\'t have permission to access this section');
  
  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <div className="text-center max-w-md">
        <Shield className="w-12 h-12 mx-auto text-slate-400 mb-4" />
        <h3 className="text-lg font-semibold text-slate-900 mb-2">
          {t('common:accessDenied.title', 'Access Denied')}
        </h3>
        <p className="text-sm text-slate-600">
          {displayMessage}
        </p>
        {permission && (
          <p className="text-xs text-slate-500 mt-2">
            {t('common:accessDenied.requiredPermission', {
              permission: Array.isArray(permission) ? permission.join(', ') : permission,
              defaultValue: `Required permission: ${Array.isArray(permission) ? permission.join(', ') : permission}`
            })}
          </p>
        )}
      </div>
    </div>
  );
}

